<template>
    <div class="tabs-stocks panel panel-default" v-if="salons">
        <form class="form-stock" role="form" :action="`/required-fields/${salon_id}`" method="POST">
            <div class="stocks-head">
                <div class="form-group">
                    <h2 v-if="role_supervisor == 0">Выберите автосалон</h2>
                    <h3>Название автосалона</h3>
                    <select :disabled="role_supervisor != 0 ? true : false" class="salon_id form-control"
                            name="salon_id" v-model="salon_id" v-on:change="salonCheck">
                        <option v-for="salon in salons" :value="`${salon.id}`"
                                :selected="salon.id==role_supervisor ? true : false">{{salon.name}}
                        </option>
                    </select>
                </div>
            </div>

            <input name="_method" value="PUT" type="hidden">
            <input name="_token" :value="`${csrf_token}`" type="hidden">

            <div class="panel panel-default">
                <div class="required-tab-white">

                    <div class="row">
                        <div class="col-lg-4">
                            <div class="equipment-bordered">
                                <table class="table table-striped striped-table-inspection">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Фамилия</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-first_name"
                                                   name="client[first_name]"
                                                   v-model="client.first_name"
                                                   :value="client.first_name"
                                            >
                                            <label for="id-first_name"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Имя</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-second_name"
                                                   name="client[second_name]"
                                                   v-model="client.second_name"
                                                   :value="client.second_name"
                                            >
                                            <label for="id-second_name"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Отчество</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-middle_name"
                                                   name="client[middle_name]"
                                                   v-model="client.middle_name"
                                                   :value="client.middle_name"
                                            >
                                            <label for="id-middle_name"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Почта</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-email"
                                                   name="client[email]"
                                                   v-model="client.email"
                                                   :value="client.email"
                                            >
                                            <label for="id-email"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Телефон</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-phone"
                                                   name="client[phone]"
                                                   v-model="client.phone"
                                                   :value="client.phone"
                                            >
                                            <label for="id-phone"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Шаг диагностики (фото)</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-diagnostics"
                                                   name="client[diagnostics]"
                                                   v-model="client.diagnostics"
                                                   :value="client.diagnostics"
                                            >
                                            <label for="id-diagnostics"><span></span></label>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="equipment-bordered">
                                <table class="table table-striped striped-table-inspection">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <!--<tr>
                                        <td>Марка</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-brand"
                                                   name="main[brand]"
                                                   disabled
                                                   checked
                                            >
                                            <label for="id-brand"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Модель</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-model"
                                                   name="main[model]"
                                                   disabled
                                                   checked
                                            >
                                            <label for="id-model"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>VIN номер (17 знаков)</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-vin_number"
                                                   name="main[vin_number]"
                                                   disabled
                                                   checked
                                            >
                                            <label for="id-vin_number"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Государственный номер</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-state_number"
                                                   name="main[state_number]"
                                                   disabled
                                                   checked
                                            >
                                            <label for="id-state_number"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Пробег</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-mileage"
                                                   name="main[mileage]"
                                                   disabled
                                                   checked
                                            >
                                            <label for="id-mileage"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Тип кузова</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-body_type_id"
                                                   name="main[body_type_id]"
                                                   disabled
                                                   checked
                                            >
                                            <label for="id-body_type_id"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Количество дверей</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-door_count"
                                                   name="main[door_count]"
                                                   disabled
                                                   checked
                                            >
                                            <label for="id-door_count"><span></span></label>
                                        </td>
                                    </tr>-->
                                    <tr>
                                        <td>Количество мест</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-seat_count"
                                                   name="main[seat_count]"
                                                   v-model="main.seat_count"
                                                   :value="main.seat_count"
                                            >
                                            <label for="id-seat_count"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Цвет кузова</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-main_color_id"
                                                   name="main[color_id]"
                                                   v-model="main.color_id"
                                                   :value="main.color_id"
                                            >
                                            <label for="id-main_color_id"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Рабочий объем (см3)</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-engine_capacity"
                                                   name="main[engine_capacity]"
                                                   v-model="main.engine_capacity"
                                                   :value="main.engine_capacity"
                                            >
                                            <label for="id-engine_capacity"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Количество владельцев</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-number_owners"
                                                   name="main[number_owners]"
                                                   v-model="main.number_owners"
                                                   :value="main.number_owners"
                                            >
                                            <label for="id-number_owners"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Гарантия</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-guarantee"
                                                   name="main[guarantee]"
                                                   v-model="main.guarantee"
                                                   :value="main.guarantee"
                                            >
                                            <label for="id-guarantee"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Покупка в кредит</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-purchase"
                                                   name="main[purchase]"
                                                   v-model="main.purchase"
                                                   :value="main.purchase"
                                            >
                                            <label for="id-purchase"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Номер полиса ОСАГО</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-number_osago_policy"
                                                   name="main[number_osago_policy]"
                                                   v-model="main.number_osago_policy"
                                                   :value="main.number_osago_policy"
                                            >
                                            <label for="id-number_osago_policy"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Наименование страховой</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-insurance_company_name"
                                                   name="main[insurance_company_name]"
                                                   v-model="main.insurance_company_name"
                                                   :value="main.insurance_company_name"
                                            >
                                            <label for="id-insurance_company_name"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>ПТС</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-pts"
                                                   name="main[pts]"
                                                   v-model="main.pts"
                                                   :value="main.pts"
                                            >
                                            <label for="id-pts"><span></span></label>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="equipment-bordered">
                                <table class="table table-striped striped-table-inspection">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Тип салона</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-interior_type_id"
                                                   name="equipment[interior_type_id]"
                                                   v-model="equipment.interior_type_id"
                                                   :value="equipment.interior_type_id"
                                            >
                                            <label for="id-interior_type_id"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Цвет салона</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-color_id"
                                                   name="equipment[color_id]"
                                                   v-model="equipment.color_id"
                                                   :value="equipment.color_id"
                                            >
                                            <label for="id-color_id"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Передние подушки безопасности</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-airbag_number_id"
                                                   name="equipment[airbag_number_id]"
                                                   v-model="equipment.airbag_number_id"
                                                   :value="equipment.airbag_number_id"
                                            >
                                            <label for="id-airbag_number_id"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Боковые подушки безопасности</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-side_airbag_number_id"
                                                   name="equipment[side_airbag_number_id]"
                                                   v-model="equipment.side_airbag_number_id"
                                                   :value="equipment.side_airbag_number_id"
                                            >
                                            <label for="id-side_airbag_number_id"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>ABS</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-abs"
                                                   name="equipment[abs]"
                                                   v-model="equipment.abs"
                                                   :value="equipment.abs"
                                            >
                                            <label for="id-abs"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Антипробуксовочная система</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-anti_slip_system"
                                                   name="equipment[anti_slip_system]"
                                                   v-model="equipment.anti_slip_system"
                                                   :value="equipment.anti_slip_system"
                                            >
                                            <label for="id-anti_slip_system"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Система курсовой устойчивости</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-stability_control"
                                                   name="equipment[stability_control]"
                                                   v-model="equipment.stability_control"
                                                   :value="equipment.stability_control"
                                            >
                                            <label for="id-stability_control"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Навигация</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-navigation"
                                                   name="equipment[navigation]"
                                                   v-model="equipment.navigation"
                                                   :value="equipment.navigation"
                                            >
                                            <label for="id-navigation"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Мультируль</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-multi_steering"
                                                   name="equipment[multi_steering]"
                                                   v-model="equipment.multi_steering"
                                                   :value="equipment.multi_steering"
                                            >
                                            <label for="id-multi_steering"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Регулируемая рулевая колонка</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-steering_column_type_id"
                                                   name="equipment[steering_column_type_id]"
                                                   v-model="equipment.steering_column_type_id"
                                                   :value="equipment.steering_column_type_id"
                                            >
                                            <label for="id-steering_column_type_id"><span></span></label>
                                        </td>
                                    </tr>
                                    <!-- просто разделитель -->
                                    <tr>
                                        <td>Датчик света</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-light_sensor"
                                                   name="equipment[light_sensor]"
                                                   v-model="equipment.light_sensor"
                                                   :value="equipment.light_sensor"
                                            >
                                            <label for="id-light_sensor"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Датчик дождя</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-rain_sensor"
                                                   name="equipment[rain_sensor]"
                                                   v-model="equipment.rain_sensor"
                                                   :value="equipment.rain_sensor"
                                            >
                                            <label for="id-rain_sensor"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Круиз-контроль</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-cruise_control"
                                                   name="equipment[cruise_control]"
                                                   v-model="equipment.cruise_control"
                                                   :value="equipment.cruise_control"
                                            >
                                            <label for="id-cruise_control"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Тип климатической установки</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-ac_type_id"
                                                   name="equipment[ac_type_id]"
                                                   v-model="equipment.ac_type_id"
                                                   :value="equipment.ac_type_id"
                                            >
                                            <label for="id-ac_type_id"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Количество зон климат контроля</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-ac_zone_id"
                                                   name="equipment[ac_zone_id]"
                                                   v-model="equipment.ac_zone_id"
                                                   :value="equipment.ac_zone_id"
                                            >
                                            <label for="id-ac_zone_id"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Обогрев лобового стекла</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-glass_heat_type_id"
                                                   name="equipment[glass_heat_type_id]"
                                                   v-model="equipment.glass_heat_type_id"
                                                   :value="equipment.glass_heat_type_id"
                                            >
                                            <label for="id-glass_heat_type_id"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Электропривод сидений</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-electric_seats_type_id"
                                                   name="equipment[electric_seats_type_id]"
                                                   v-model="equipment.electric_seats_type_id"
                                                   :value="equipment.electric_seats_type_id"
                                            >
                                            <label for="id-electric_seats_type_id"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Память сидений</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-memory_seats_type_id"
                                                   name="equipment[memory_seats_type_id]"
                                                   v-model="equipment.memory_seats_type_id"
                                                   :value="equipment.memory_seats_type_id"
                                            >
                                            <label for="id-memory_seats_type_id"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Вентиляция сидений</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-vent_seats_type_id"
                                                   name="equipment[vent_seats_type_id]"
                                                   v-model="equipment.vent_seats_type_id"
                                                   :value="equipment.vent_seats_type_id"
                                            >
                                            <label for="id-vent_seats_type_id"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Подогрев сидений</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-seats_heat_type_id"
                                                   name="equipment[seats_heat_type_id]"
                                                   v-model="equipment.seats_heat_type_id"
                                                   :value="equipment.seats_heat_type_id"
                                            >
                                            <label for="id-seats_heat_type_id"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Электростеклоподъемники</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-power_windows"
                                                   name="equipment[power_windows]"
                                                   v-model="equipment.power_windows"
                                                   :value="equipment.power_windows"
                                            >
                                            <label for="id-power_windows"><span></span></label>
                                        </td>
                                    </tr>
                                    <!-- просто разделитель -->
                                    <tr>
                                        <td>Обогрев зеркал</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-heated_mirrors"
                                                   name="equipment[heated_mirrors]"
                                                   v-model="equipment.heated_mirrors"
                                                   :value="equipment.heated_mirrors"
                                            >
                                            <label for="id-heated_mirrors"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Электропривод зеркал</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-power_mirrors"
                                                   name="equipment[power_mirrors]"
                                                   v-model="equipment.power_mirrors"
                                                   :value="equipment.power_mirrors"
                                            >
                                            <label for="id-power_mirrors"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Электроскладывание зеркал</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-electric_folding_mirrors"
                                                   name="equipment[electric_folding_mirrors]"
                                                   v-model="equipment.electric_folding_mirrors"
                                                   :value="equipment.electric_folding_mirrors"
                                            >
                                            <label for="id-electric_folding_mirrors"><span></span></label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Пневматическая подвеска</td>
                                        <td>
                                            <input type="checkbox"
                                                   id="id-air_suspension"
                                                   name="equipment[air_suspension]"
                                                   v-model="equipment.air_suspension"
                                                   :value="equipment.air_suspension"
                                            >
                                            <label for="id-air_suspension"><span></span></label>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4">
                            <button type="submit" class="btn btn-primary btn-sm">Сохранить</button>
                            <a href="/home" class="btn btn-cancel btn-sm">Отмена</a>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <h3 v-else>Загрузка салонов ...</h3>
</template>

<script>
    export default {
        data() {
            return {
                limit: 0,
                salon_id: this.session_salon_id,
                client: {},
                main: {},
                equipment: {},
            }
        },
        props: ['csrf_token', 'role_supervisor', 'session_salon_id'],
        asyncComputed: {
            salons() {
                return axios
                    .get('/api/salons', {
                        params: {
                            q: '',
                            limit: this.limit
                        }
                    })
                    .then(({data}) => {
                        //if (this.session_salon_id != '') this.salon_id = this.session_salon_id
                        //else this.salon_id = data.data[0].id
                        this.salonCheck()
                        return data.data
                    })
            },
        },
        methods: {
            salonCheck() {
                this.resetCheck()
                return axios
                    .get('/api/required_fields/' + this.salon_id, {})
                    .then(({data}) => {
                        if (data.client) this.client = data.client
                        if (data.main) this.main = data.main
                        if (data.equipment) this.equipment = data.equipment
                    })
            },
            resetCheck() {
                this.client = {}
                this.main = {}
                this.equipment = {}
            }
        },
        created: function () {
            if (this.role_supervisor != 0) {
                this.salon_id = this.role_supervisor
                this.salonCheck()
            }
        }
    }
</script>

<style lang="less">
    @import "../../less/_boot";

    .required-tab-white {
        background-color: #fff;
        padding: 10px;
    }

    .required-tab-white .btn-cancel {
        margin-top: 20px;
    }

    .cos-form-5 {
        box-sizing: border-box;
        width: 19.5%;
        display: block;
        float: left;
        margin-left: 0.5%;
    }

    .cos-form-5:first-child {
        margin-left: 0;
    }

    .cos-form-5 select {
        color: #999999;
    }

    .select-data .date_from {
        border-right: none;
        width: 50%;
        display: inline-block;
    }

</style>




// WEBPACK FOOTER //
// TabsRequiredFields.vue?00f791bb